// extracted by mini-css-extract-plugin
export default {"generationFinishPage":"VideoArtFinishPage_generationFinishPage__kY0CH","container":"VideoArtFinishPage_container__peVo6"};